var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbArrowUpRightFromSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5a2 2 0 012-2h4a1 1 0 010 2H5v14h14v-4a1 1 0 112 0v4a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm11 0a1 1 0 110-2h6a1 1 0 011 1v6a1 1 0 11-2 0V6.414l-8.293 8.293a1 1 0 01-1.414-1.414L17.586 5H14z",
    fill: "#fff"
  })));
}

export default SvgIbArrowUpRightFromSquare;